import { FormlyFieldConfig } from 'ng-formly';
export const reporttemplateFields: Array<FormlyFieldConfig> = [
    {
        key: 'group',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: 'Report Group Name',
            required: true,
            label: 'Report Group Name'
        }
    },
    {
        key: 'developmentstatus',
        type: 'select-component',
        className: 'col-md-2',
        defaultValue: 'Yet to Start',
        templateOptions: {
            options: [{
                label: 'Yet to Start',
                value: 'Yet to Start'
            }, {
                label: 'Work in Progress',
                value: 'Work in Progress'
            }, {
                label: 'Completed',
                value: 'Completed'
            }, {
                label: 'Approved',
                value: 'Approved'
            }],
            label: 'Development Status',
            required: true,
            placeholder: ''
        }
    },
    {
        key: 'developmentpriority',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Development Priority'
        }
    },
    {
        key: 'developmentnotes',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Development Team Notes'
        }
    },

    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-3',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Name'
        }
    },

    {
        key: 'templatetype',
        type: 'select-component',
        defaultValue: '1',
        className: 'col-md-3',
        templateOptions: {
            options: [{
                label: 'Default Report',
                value: '1'
            }, {
                label: 'Letter',
                value: '2'
            }, {
                label: 'Comprehensive Report',
                value: '3'
            }],
            label: 'Template Type',
            required: true,
            placeholder: ''
        }
    },
    {
        key: 'status',
        type: 'select-component',
        className: 'col-md-3',
        hideExpression: '!model.fieldtype',
        defaultValue: 'active',
        templateOptions: {
            options: [{
                label: 'Active',
                value: 'active'
            }, {
                label: 'In Active',
                value: 'inactive'
            }],
            label: 'Status',
            required: true,
            default: 'active',
            placeholder: 'Select Status'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'templatehtml',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Template HTML (Please Minify the HTML before Pasting here)',
            description: 'Handlebars Template for the report - HTML portion', rows: 10
        }
    },
    {
        key: 'templatejs',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Template Javascript',
            description: 'Handlebars Template for the report - Javascript', rows: 10
        }
    },
    {
        key: 'templatecss',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Template Styles',
            description: 'Handlebars Template for the report - Styles', rows: 10
        }
    },
    {
        type: 'repeatedsection',
        key: 'dataelements',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add DataElement',
                label: 'DataElements'
            },
            fieldGroup: [
                {
                    className: 'col-md-2',
                    type: 'input-field',
                    key: 'index',
                    templateOptions: {
                        type: 'text',
                        label: 'Index',
                        required: false,
                        description: 'Sort Order'
                    },
                },
                {
                    key: 'name',
                    type: 'input-field',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Unique Name',
                        required: true,
                        description: 'Name to use in Report HTML Template'
                    }
                },
                {
                    key: 'dataelement',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        label: 'DataElement',
                        required: true,
                        description: 'Enter ObjectId',
                        type: 'dataelement'
                    }
                },
                {
                    key: 'type',
                    type: 'select-component',
                    className: 'col-md-2',
                    templateOptions: {
                        options: [{
                            label: 'Table',
                            value: 'table'
                        }, {
                            label: 'Metric',
                            value: 'metric'
                        }, {
                            label: 'Pie Chart',
                            value: 'pie'
                        }, {
                            label: 'Line Chart',
                            value: 'line'
                        }, {
                            label: 'Bar Chart',
                            value: 'bar'
                        }, {
                            label: 'Area Chart',
                            value: 'area'
                        },
                        {
                            label: 'Scatter Chart',
                            value: 'scatter'
                        }, {
                            label: 'Radar Chart',
                            value: 'radar'
                        }, {
                            label: 'Funnel Chart',
                            value: 'funnel'
                        }, {
                            label: 'Graph Chart',
                            value: 'graph'
                        }, {
                            label: 'Heatmap',
                            value: 'heatmap'
                        }, {
                            label: 'Gauge',
                            value: 'gauge'
                        }, {
                            label: 'Boxplot',
                            value: 'boxplot'
                        }, {
                            label: 'Punch Card',
                            value: 'punchcard'
                        }, {
                            label: 'Candle Stick',
                            value: 'candlestick'
                        }, {
                            label: 'Parallel',
                            value: 'parallel'
                        }],
                        label: 'Type',
                        required: true,
                        placeholder: 'Select Type'
                    }
                },
                {
                    key: 'gridcolumns',
                    className: 'col-md-12',
                    hideExpression: '(model.type !== "table")',

                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: '',
                        description: 'Provide JSON for Grid Columns based on ag-grid for printing',
                        required: true,
                        label: 'Table Grid Column JSON'
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.type === "input-field") ? true : false'
                    }
                },
            ]
        }
    },
    {
        key: 'formfields',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            label: 'Form Fields JSON (Please Minify the JSON before Pasting here)',
            required: true,
            description: 'Form Fields', rows: 10
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/reporttemplate.ts